<template>
  <v-autocomplete
    v-model="select"
    :label="$t('filterAction')"
    :items="items"
    item-text="text"
    item-value="value"
    prepend-icon="mdi-archive-eye"
    dense
    filled
    hide-details
    solo-inverted
    @change="setSelectActionLog"
  ></v-autocomplete>
</template>
<script>
export default {
  name: "components-common-filters-select-type-User",
  data: () => ({
    // V-select
    select: "",
    items: [],
  }),
  computed: {
    logLevel() {
      return this.$store.state.filters.selectUserLogLevel.value;
    },
    selectItems() {
      return [
        {
          text: this.$t("accountBlocked"),
          value: "ACCOUNTBLOCKED",
        },
        {
          text: this.$t("accountSuspended"),
          value: "ACCOUNTSUSPENDED",
        },
        {
          text: this.$t("admPasswordUpdated"),
          value: "ADMPASSWORDUPDATED",
        },
        {
          text: this.$t("agentCreditAdded"),
          value: "AGENTCREDITADDED",
        },
        {
          text: this.$t("agentCreditReseted"),
          value: "AGENTCREDITRESETED",
        },
        {
          text: this.$t("agentInserted"),
          value: "AGENTINSERTED",
        },
        {
          text: this.$t("agentPasswordUpdated"),
          value: "AGENTPASSWORDUPDATED",
        },
        {
          text: this.$t("agentRoutesInserted"),
          value: "AGENTROUTESINSERTED",
        },
        {
          text: this.$t("agentRoutesUpdated"),
          value: "AGENTROUTESUPDATED",
        },
        {
          text: this.$t("agentStatusUpdated"),
          value: "AGENTSTATUSUPDATED",
        },
        {
          text: this.$t("agentUpdated"),
          value: "AGENTUPDATED",
        },
        {
          text: this.$t("areaInserted"),
          value: "AREAINSERTED",
        },
        {
          text: this.$t("areaUpdated"),
          value: "AREAUPDATED",
        },
        {
          text: this.$t("betCanceledLog"),
          value: "BETCANCELED",
        },
        {
          text: this.$t("betPaid"),
          value: "BETPAID",
        },
        {
          text: this.$t("betPaidByAdm"),
          value: "PAIDBETAGENT",
        },
        {
          text: this.$t("betValidated"),
          value: "BETVALIDATED",
        },
        {
          text: this.$t("bonusChanged"),
          value: "BONUSCHANGED",
        },
        {
          text: this.$t("cancelWithdrawByOperator"),
          value: "CANCELWITHDRAWBYOPERATOR",
        },
        {
          text: this.$t("cashoutAuthorizedByAdm"),
          value: "CASHOUTAUTHORIZEDBYADM",
        },
        {
          text: this.$t("cashoutDetachedAuthorizedByAdm"),
          value: "CASHOUTDETACHEDAUTHORIZEDBYADM",
        },
        {
          text: this.$t("cashoutDetachedAuthorizedByCollab"),
          value: "CASHOUTDETACHEDAUTHORIZEDBYCOLAB",
        },
        {
          text: this.$t("collectorConsolidatedCash"),
          value: "COLLECTORCONSOLIDATEDCASH",
        },
        {
          text: this.$t("collectorEntryInserted"),
          value: "COLLECTORENTRYINSERTED",
        },
        {
          text: this.$t("collectorInserted"),
          value: "COLLECTORINSERTED",
        },
        {
          text: this.$t("collectorRoutesInserted"),
          value: "COLLECTORROUTESINSERTED",
        },
        {
          text: this.$t("collectorUpdated"),
          value: "COLLECTORUPDATED",
        },
        {
          text: this.$t("updatedCommissions"),
          value: "COMISSIONSUPDATED",
        },
        {
          text: this.$t("updateOperatorPaymentMethods"),
          value: "UPDATEOPERATORPAYMENTMETHODSBYADM",
        },
        {
          text: this.$t("creditCanceled"),
          value: "CREDITCANCELED",
        },
        {
          text: this.$t("creditSold"),
          value: "CREDITSOLD",
        },
        {
          text: this.$t("depositForPlayerBillet"),
          value: "DEPOSITFORPLAYERBILLET",
        },
        {
          text: this.$t("depositOnline"),
          value: "DEPOSITONLINE",
        },
        {
          text: this.$t("detachedDepositByAdm"),
          value: "DETACHEDDEPOSITBYADM",
        },
        {
          text: this.$t("detachedDepositByColab"),
          value: "DETACHEDDEPOSITBYCOLAB",
        },
        {
          text: this.$t("depositOnlinePay4Fun"),
          value: "DEPOSITONLINEP4F",
        },
        {
          text: this.$t("entryDealInserted"),
          value: "ENTRYDEALINSERTED",
        },
        {
          text: this.$t("eventCanceled"),
          value: "EVENTCANCELED",
        },
        {
          text: this.$t("eventMarketChanged"),
          value: "EVENTMARKETCHANGED",
        },
        {
          text: this.$t("eventOutcomeUpdated"),
          value: "EVENTOUTCOMEUPDATED",
        },
        {
          text: this.$t("eventStatusChanged"),
          value: "EVENTSTATUSCHANGED",
        },
        {
          text: this.$t("insertCasinoGamesAdm"),
          value: "INSERTCASINOGAMESBYADM",
        },
        {
          text: this.$t("invalidLevel"),
          value: "INVALIDLEVEL",
        },
        {
          text: this.$t("localManagerInserted"),
          value: "LOCALINSERTED",
        },
        {
          text: this.$t("localManagerUpdated"),
          value: "LOCALUPDATED",
        },
        {
          text: this.$t("localManagerPasswordUpdated"),
          value: "LOCALPASSWORDUPDATED",
        },
        {
          text: this.$t("loginSuccess"),
          value: "LOGINSUCCESS",
        },
        {
          text: this.$t("marketInserted"),
          value: "MARKETINSERTED",
        },
        {
          text: this.$t("operatorConfigUpdated"),
          value: "OPERATORCONFIGUPDATED",
        },
        {
          text: this.$t("operatorOnlineConfigUpdated"),
          value: "OPERATORONLINECONFIGUPDATED",
        },
        {
          text: this.$t("outcomesInserted"),
          value: "OUTCOMESINSERTED",
        },
        {
          text: this.$t("outcomeUpdated"),
          value: "OUTCOMEUPDATED",
        },
        {
          text: this.$t("placeBet"),
          value: "PLACEBET",
        },
        {
          text: this.$t("playerAddressDataUpdated"),
          value: "PLAYERADDRESSDATAUPDATED",
        },
        {
          text: this.$t("playerBankDataUpdated"),
          value: "PLAYERBANKDATAUPDATED",
        },
        {
          text: this.$t("playerContactDataUpdated"),
          value: "PLAYERCONTACTDATAUPDATED",
        },
        {
          text: this.$t("playerInserted"),
          value: "PLAYERINSERTED",
        },
        {
          text: this.$t("playerInstantCashout"),
          value: "PLAYERINSTANTCASHOUT",
        },
        {
          text: this.$t("betCashout"),
          value: "BETCASHOUT",
        },
        {
          text: this.$t("depositOnlineBrasilCash"),
          value: "DEPOSITONLINEBRCASH",
        },
        {
          text: this.$t("playerPasswordUpdated"),
          value: "PLAYERPASSWORDUPDATED",
        },
        {
          text: this.$t("playerPersonalDataUpdated"),
          value: "PLAYERPERSONALDATAUPDATED",
        },
        {
          text: this.$t("playerUpdated"),
          value: "PLAYERUPDATED",
        },
        {
          text: this.$t("insertedRegional"),
          value: "REGIONALINSERTED",
        },
        {
          text: this.$t("regionalPasswordUpdated"),
          value: "REGIONALPASSWORDUPDATED",
        },
        {
          text: this.$t("regionalUpdated"),
          value: "REGIONALUPDATED",
        },
        {
          text: this.$t("incompleteRegistration"),
          value: "REGISTRATIONINCOMPLETE",
        },
        {
          text: this.$t("removeCasinoGamesByAdm"),
          value: "REMOVECASINOGAMESBYADM",
        },
        {
          text: this.$t("tournamentEntered"),
          value: "TOURNAMENTINSERTED",
        },
        {
          text: this.$t("userStatusUpdated"),
          value: "USERSTATUSUPDATED",
        },
        {
          text: this.$t("updateAffiliateFee"),
          value: "UPDATE_AFFILIATE_FEE",
        },
        {
          text: this.$t("updateFixedAffiliateCommission"),
          value: "UPDATE_AFFILIATE_COMISSION",
        },
        {
          text: this.$t("updateAffiliateCommissionType"),
          value: "UPDATE_COMMISSION_TYPE_AFFILIATE",
        },
        {
          text: this.$t("updateAffiliateVariableCommission"),
          value: "UPDATE_VARIABLE_COMMISSION_AFFILIATES",
        },
        {
          text: this.$t("withdrawIntention"),
          value: "WITHDRAWINTENTION",
        },
        {
          text: this.$t("wrongPassword"),
          value: "WRONGPASSWORD",
        },
        {
          text: this.$t("playerSuspended"),
          value: "PLAYERSUSPENDED",
        },
        {
          text: this.$t("promotionInserted"),
          value: "PROMOTIONINSERTED",
        },
        {
          text: this.$t("promotionDeleted"),
          value: "PROMOTIONDELETED",
        },
        {
          text: this.$t("bonusConsumed"),
          value: "BONUSPROMOCAO",
        },
        {
          text: this.$t("groupCreated"),
          value: "GROUPCREATED",
        },
        {
          text: this.$t("groupUpdated"),
          value: "GROUPUPDATED",
        },
        // {
        //   text: this.$t("expenses.logs.createExpense"),
        //   value: "CREATEEXPENSE",
        // },
        // {
        //   text: this.$t("expenses.logs.editExpense"),
        //   value: "EDITEXPENSE",
        // },
        // {
        //   text: this.$t("expenses.logs.removeExpense"),
        //   value: "REMOVEEXPENSE",
        // },
      ];
    },
  },
  mounted() {
    this.changeLogItems(this.logLevel);
    if (this.logLevel) {
      this.select = "ADMPASSWORDUPDATED";
      this.$store.commit("setSelectActionLog", this.select);
    }
  },
  watch: {
    logLevel(val) {
      this.changeLogItems(val);
      this.settingSelectStatus(val);
    },
  },
  methods: {
    // Quando uma nova array de actions é chamada, seta uma action
    // no select e passa a mesma como status pro componente
    settingSelectStatus(val) {
      if (val == "backoffice") {
        this.select = "ADMPASSWORDUPDATED";
        this.$store.commit("setSelectActionLog", this.select);
      }
      if (val == "agent") {
        this.select = "PLACEBET";
        this.$store.commit("setSelectActionLog", this.select);
      }
      if (val == "player") {
        this.select = "DEPOSITONLINE";
        this.$store.commit("setSelectActionLog", this.select);
      }
      if (val == "collaborator") {
        this.select = "LOGINSUCCESS";
        this.$store.commit("setSelectActionLog", this.select);
      }
    },

    setSelectActionLog(status) {
      this.$store.commit("setSelectActionLog", status);
    },
    changeLogItems(logLevel) {
      // Zera o valor de items
      this.items = [];
      // Arrays que serão inseridos em cada seção, conferência é realizada de acordo com o namedrawer
      // Valors do array são os valores dos logs necessários de que vem do selectItems

      const backoffice = [
        "PLAYERSUSPENDED",
        "ADMPASSWORDUPDATED",
        "AGENTCREDITADDED",
        "AGENTCREDITRESETED",
        "AGENTINSERTED",
        "AGENTROUTESINSERTED",
        "AGENTROUTESUPDATED",
        "AGENTSTATUSUPDATED",
        "AGENTUPDATED",
        "AREAINSERTED",
        "AREAUPDATED",
        "BETCANCELED",
        "BETPAID",
        "PAIDBETAGENT",
        "BONUSCHANGED",
        "CANCELWITHDRAWBYOPERATOR",
        "CASHOUTAUTHORIZEDBYADM",
        "CASHOUTDETACHEDAUTHORIZEDBYADM",
        "COLLECTORCONSOLIDATEDCASH",
        "COLLECTORENTRYINSERTED",
        "COLLECTORUPDATED",
        "COMISSIONSUPDATED",
        "CREDITCANCELED",
        "DEPOSITFORPLAYERBILLET",
        "DETACHEDDEPOSITBYADM",
        "ENTRYDEALINSERTED",
        "EVENTCANCELED",
        "EVENTMARKETCHANGED",
        "EVENTOUTCOMEUPDATED",
        "EVENTSTATUSCHANGED",
        "INSERTCASINOGAMESBYADM",
        "LOCALUPDATED",
        "LOCALINSERTED",
        "LOCALPASSWORDUPDATED",
        "MARKETINSERTED",
        "OPERATORCONFIGUPDATED",
        "OPERATORONLINECONFIGUPDATED",
        "OUTCOMESINSERTED",
        "OUTCOMEUPDATED",
        "PLAYERUPDATED",
        "REGIONALINSERTED",
        "REGIONALPASSWORDUPDATED",
        "REGIONALUPDATED",
        "REMOVECASINOGAMESBYADM",
        "TOURNAMENTINSERTED",
        "COLLECTORINSERTED",
        "USERSTATUSUPDATED",
        "UPDATEOPERATORPAYMENTMETHODSBYADM",
        "UPDATE_AFFILIATE_FEE",
        "UPDATE_AFFILIATE_COMISSION",
        "UPDATE_COMMISSION_TYPE_AFFILIATE",
        "UPDATE_VARIABLE_COMMISSION_AFFILIATES",
        "WRONGPASSWORD",
        "LOGINSUCCESS",
        "PROMOTIONINSERTED",
        "PROMOTIONDELETED",
        "GROUPCREATED",
        "GROUPUPDATED",
        "CREATEEXPENSE",
        "EDITEXPENSE",
        "REMOVEEXPENSE",
      ];

      const agent = [
        "PLACEBET",
        "BETPAID",
        "BETCANCELED",
        "BETVALIDATED",
        "PLAYERINSERTED",
        "AGENTPASSWORDUPDATED",
        "CREDITSOLD",
        "WRONGPASSWORD",
        "LOGINSUCCESS",
      ];

      const player = [
        "PLAYERSUSPENDED",
        "DEPOSITONLINE",
        "DEPOSITONLINEP4F",
        "PLACEBET",
        "PLAYERPERSONALDATAUPDATED",
        "PLAYERCONTACTDATAUPDATED",
        "PLAYERADDRESSDATAUPDATED",
        "PLAYERBANKDATAUPDATED",
        "PLAYERPASSWORDUPDATED",
        "PLAYERINSTANTCASHOUT",
        "WITHDRAWINTENTION",
        "WRONGPASSWORD",
        "LOGINSUCCESS",
        "BONUSPROMOCAO",
        "BETCASHOUT",
        "DEPOSITONLINEBRCASH",
      ];

      const collaborator = [
        "AFFILIATEINSERTED",
        "AFFILIATEUPDATED",
        "LOCALINSERTED",
        "LOCALUPDATED",
        "REGIONALINSERTED",
        "REGIONALUPDATED",
        "CASHOUTAUTHORIZEDBYADM",
        "CASHOUTDETACHEDAUTHORIZEDBYCOLAB",
        "DETACHEDDEPOSITBYCOLAB",
        "BETCANCELED",
        "BONUSCHANGED",
        "OPERATORONLINECONFIGUPDATED",
        "PLAYERUPDATED",
        "WRONGPASSWORD",
        "LOGINSUCCESS",
        "PLAYERSUSPENDED",
        "USERSTATUSUPDATED",
        "CREATEEXPENSE",
        "EDITEXPENSE",
        "REMOVEEXPENSE",
      ];

      // Para o valor backoffice o array retorna todos os valores do select
      // const backoffice = this.selectItems.map((item) => item.value);
      const type = [
        { text: "backoffice", value: backoffice },
        { text: "agent", value: agent },
        { text: "player", value: player },
        { text: "collaborator", value: collaborator },
      ];

      const areaRelatedLogs = [
        "AGENTROUTESINSERTED",
        "AGENTROUTESUPDATED",
        "AREAINSERTED",
        "AREAUPDATED",
      ];

      this.selectItems.map((log) => {
        type.map((item) => {
          // Compara o valor do logLevel com o valor do array type para acessar o valor do text
          if (item.text == logLevel) {
            // Detro do array type faz um for somente no array necessário (agent, player, backoffice)
            item.value.map((value) => {
              // Verifica se o valor
              if (log.value == value) {
                const retail = localStorage.getItem("operator-retail");
                const isRetailZero = JSON.parse(retail) == 0;

                if (isRetailZero) {
                  const isLogAboutArea = areaRelatedLogs.includes(log.value);
                  if (!isLogAboutArea) {
                    this.items.push(log);
                  }
                } else {
                  this.items.push(log);
                }
              }
            });
          }
        });
      });
    },
  },
};
</script>
